export default __webpack_public_path__ + "static/media/header.d7a15d28.svg";